export default __webpack_public_path__ + "static/media/element_29.a9d9551b.webp";